module.exports = __webpack_public_path__ + "static/media/3.b0b08810.png";